<script>
export default {
    data() {
        return {
            mobile: false,
        }
    },
    methods: {
        //
    },
    mounted() {
        this.mobile = screen.width <=760;
    },
}
</script>
